import { Popover } from "@amzn/awsui-components-react-v3";
import { saasRestrictionDefinitions } from "../Itemv2/questionOption.constants";
import * as React from "react";

export const getSaasDefinition = (key: string) => {
    const definition = saasRestrictionDefinitions.find(def => def.keyword === key)?.definition || "";
    return <Popover
      content={definition}
    >{key}</Popover>
  }